<template>
    <el-form ref="ruleFormRef" class="insured-dialog-form" label-position="top" :rules="rules" :model="values" @submit.prevent>
        <div class="row">
            <div class="col-sm-5 pe-5">
                <p class="font-weight-bold p-header lead mb-0 p-2 mb-1">{{ $t('companyName') }}</p>
                <hr class="horizontal dark m-0 mb-3" />
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item :label="$t('voen')" prop="voen" label-position="top">
                            <el-input v-model="values.voen" maxlength="10" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item :label="$t('companyName')" prop="companyName" label-position="top">
                            <el-input v-model="values.companyName" maxlength="200" />
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item :label="$t('companyName') + $t('eng')" label-position="top">
                            <el-input v-model="values.companyNameEn" maxlength="200" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item :label="$t('legalPersonType')" label-position="top">
                            <el-select v-model="values.typeId" filterable style="width: 100%">
                                <el-option v-for="item in orgTypes" :key="item.id" :label="item.name"
                                    :value="item.id" />
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <el-form-item :label="$t('activity')" label-position="top">
                            <el-input v-model="values.activity" maxlength="200" />
                        </el-form-item>
                    </div>
                </div>
                <p class="font-weight-bold p-header lead mb-0 p-2 mb-1 mt-3">{{ $t('phone') }}</p>
                <hr class="horizontal dark m-0 mb-3" />
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item :label="$t('phone')" prop="phones" label-position="top">
                            <el-input v-model="values.phones" maxlength="200" placeholder="+994501234567" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item :label="$t('fax')" label-position="top">
                            <el-input v-model="values.fax" maxlength="200" />
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item :label="$t('email')" prop="emails" label-position="top">
                            <el-input v-model="values.emails" maxlength="200" placeholder="example@email.com" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item :label="$t('contactPerson')" label-position="top">
                            <el-input v-model="values.contacts" maxlength="200" />
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="col-sm-7">
                <p class="font-weight-bold p-header lead mb-0 p-2 mb-1">{{ $t('address') }}</p>
                <hr class="horizontal dark m-0 mb-3" />
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item :label="$t('country')" label-position="top">
                            <el-select v-model="values.countryId" filterable style="width: 100%">
                                <el-option v-for="country in countries" :key="country.countryId"
                                    :label="country.countryName" :value="country.countryId" />
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item :label="$t('city')" label-position="top">
                            <el-select v-model="values.townId" filterable style="width: 100%">
                                <el-option v-for="town in towns" :key="town.townId" :label="town.townName"
                                    :value="town.townId" />
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-2">
                        <el-form-item label="&nbsp;" label-position="top">
                            <el-select v-model="values.townType" style="width: 100%">
                                <el-option :label="$t('cityType')" value="şəh." />
                                <el-option :label="$t('districtType')" value="r-nu" />
                                <el-option label="MR" value="MR" />
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item :label="$t('street')" prop="street" label-position="top">
                            <el-input v-model="values.street" maxlength="200" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-2">
                        <el-form-item :label="$t('house')" label-position="top">
                            <el-input v-model="values.house" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-2">
                        <el-form-item :label="$t('apartment')" label-position="top">
                            <el-input v-model="values.apt" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-2">
                        <el-form-item :label="$t('postalCode')" label-position="top">
                            <el-input v-model="values.zip" maxlength="4" />
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <el-form-item :label="$t('address') + $t('eng')" label-position="top">
                            <el-input v-model="values.addressEn" maxlength="200" />
                        </el-form-item>
                    </div>
                </div>

                <p class="font-weight-bold p-header lead mb-0 p-2 mb-1 mt-3">{{ $t('account') }}</p>
                <hr class="horizontal dark m-0 mb-3" />
                <div class="row">
                    <div class="col-sm-4">
                        <el-form-item :label="$t('vat')" label-position="top">
                            <el-input v-model="values.vat" type="number" style="width: 100%" />
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item :label="$t('parentCompany')" label-position="top">
                            <el-select v-model="values.parentId" filterable clearable style="width: 100%">
                                <el-option v-for="company in companies" :key="company.id" :label="company.name"
                                    :value="company.id" />
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item :label="$t('companyTypeName')" label-position="top">
                            <el-select v-model="values.companyTypeIds" filterable clearable multiple style="width: 100%">
                                <el-option v-for="item in companyTypes" :key="item.id" :label="item.name"
                                    :value="item.id" />
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </div>

        <div class="insured-dialog-footer">
            <button type="button" class="insured-dialog-btn insured-dialog-btn--muted" @click="$emit('close-dialog')">
                {{ $t('btnCancel') }}
            </button>
            <button type="button" class="insured-dialog-btn insured-dialog-btn--primary" @click="SubmitForm">
                {{ !editing ? $t('btnInsert') : $t('accept') }}
            </button>
        </div>
    </el-form>
</template>
<script>
import Source from "@/project/Source/client";
import Core from "@/project/Source/core";
import SourceDict from "@/project/Source/dictionary";

export default {
    name: "CatalogCompanyListDialog",
    props: {
        editing: Boolean,
        object: Object
    },
    data() {
        return {
            values: {
                voen: '',
                companyName: '',
                companyNameEn: '',
                typeId: null,
                activity: '',
                countryId: null,
                townId: null,
                townType: 'şəh.',
                street: '',
                house: '',
                apt: '',
                zip: '',
                addressEn: '',
                vat: 0,
                phones: '',
                fax: '',
                contacts: '',
                emails: '',
                parentId: 0,
                account: '',
                companyTypeIds: []
            },
            countries: [],
            towns: [],
            orgTypes: [],
            companies: [],
            companyTypes: [],
            rules: {
                voen: [
                    { required: true, message: this.$t('formRequired'), trigger: 'change' },
                    { pattern: /^[0-9]{10}$/, message: this.$t('voenValidation'), trigger: 'change' }
                ],
                companyName: [{ required: true, message: this.$t('formRequired'), trigger: 'change' }],
                street: [{ required: true, message: this.$t('formRequired'), trigger: 'change' }],
                phones: [
                    {
                        pattern: /^$|^(\+?994\s?)?([0-9]{2}[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}|[0-9]{9})$/,
                        message: this.$t('invalidPhone') || 'Telefon formatı düzgün deyil (məs: +994501234567)',
                        trigger: ['blur', 'change']
                    }
                ],
                emails: [
                    {
                        type: 'email',
                        message: this.$t('invalidEmail') || 'Email formatı düzgün deyil',
                        trigger: ['blur', 'change']
                    }
                ]
            }
        }
    },
    mounted() {
        this.LoadCountries();
        this.LoadTowns();
        this.LoadOrgTypes();
        this.LoadCompanies();
        this.LoadCompanyTypes();
        if (this.editing && this.object) {
            this.values = { ...this.object }
            if (!this.values.companyTypeIds || !Array.isArray(this.values.companyTypeIds)) {
                if (this.values.companyTypeId) {
                    this.values.companyTypeIds = [this.values.companyTypeId]
                } else {
                    this.values.companyTypeIds = []
                }
            }
        }
    },
    methods: {
        LoadCountries() {
            const data = {
                "requestCorrelationId": crypto.randomUUID()
            };
            Core.Country(data).then((response) => {
                if (response && response.data && response.data.isSuccess === true) {
                    this.countries = response.data.data || [];
                    if (this.countries.length > 0 && !this.values.countryId) {
                        this.values.countryId = this.countries[0].countryId;
                    }
                }
            }).catch((error) => {
                console.error('Error loading countries:', error);
            });
        },
        LoadTowns() {
            const data = {
                "requestCorrelationId": crypto.randomUUID()
            };
            Core.Town(data).then((response) => {
                if (response && response.data && response.data.isSuccess === true) {
                    this.towns = response.data.data || [];
                    if (this.towns.length > 0 && !this.values.townId) {
                        this.values.townId = this.towns[0].townId;
                    }
                }
            }).catch((error) => {
                console.error('Error loading towns:', error);
            });
        },
        LoadOrgTypes() {
            const data = {
                "requestCorrelationId": crypto.randomUUID()
            };
            Source.OrganizationType(data).then((response) => {
                if (response && response.data && response.data.isSuccess === true) {
                    this.orgTypes = response.data.data || [];
                }
            }).catch((error) => {
                console.error('Error loading organization types:', error);
            });
        },
        LoadCompanies() {
            const data = {
                "requestCorrelationId": crypto.randomUUID(),
                "ctp": 7
            };
            SourceDict.Companies(data).then((response) => {
                if (response && response.data && response.data.isSuccess === true) {
                    this.companies = response.data.data || [];
                }
            }).catch((error) => {
                console.error('Error loading companies:', error);
            });
        },
        LoadCompanyTypes() {
            const data = {
                "requestCorrelationId": crypto.randomUUID()
            };
            Source.CompanyType(data).then((response) => {
                if (response && response.data && response.data.isSuccess === true) {
                    this.companyTypes = response.data.data || [];
                }
            }).catch((error) => {
                console.error('Error loading company types:', error);
            });
        },
        SubmitForm() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
                    const data = {
                        "requestCorrelationId": crypto.randomUUID(),
                        "data": {
                            "id": this.editing ? this.object.id : 0,
                            "voen": this.values.voen,
                            "companyName": this.values.companyName,
                            "companyNameEn": this.values.companyNameEn,
                            "typeId": this.values.typeId,
                            "activity": this.values.activity,
                            "countryId": this.values.countryId,
                            "townId": this.values.townId,
                            "townType": this.values.townType,
                            "street": this.values.street,
                            "house": this.values.house,
                            "apt": this.values.apt,
                            "zip": this.values.zip,
                            "addressEn": this.values.addressEn,
                            "vat": this.values.vat,
                            "phones": this.values.phones,
                            "fax": this.values.fax,
                            "contacts": this.values.contacts,
                            "emails": this.values.emails,
                            "parentId": this.values.parentId,
                            "account": this.values.account
                        },
                        "companyTypeIds": this.values.companyTypeIds || []
                    }

                    if (this.editing) {
                        Source.EditCompanyRequest(data).then((response) => {
                            if (response && response.data && response.data.isSuccess === true) {
                                this.$emit('insert-dialog')
                            }
                        }).catch((error) => {
                            console.error('Error editing company:', error);
                        })
                    } else {
                        Source.NewCompanyRequest(data).then((response) => {
                            if (response && response.data && response.data.isSuccess === true) {
                                this.$emit('insert-dialog')
                            }
                        }).catch((error) => {
                            console.error('Error creating company:', error);
                        })
                    }
                }
            })
        }
    },
}
</script>
